import { Pipe, PipeTransform} from '@angular/core';
@Pipe({
    name : 'OrdStatusFilter'
})

export class OrdStatusFilter implements PipeTransform{
    transform(orders: any[], searchTerm : any): any{
        if (orders==null || orders==undefined){
            return null;
        }
        return orders.filter(order=>{
            return (order.txn_no.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1);

        });
    }
}


// WEBPACK FOOTER //
// ./src/filters/ordStatusFilter.pipe.ts